import { render, staticRenderFns } from "./LessonEditForm.vue?vue&type=template&id=0ddefa7f&scoped=true&"
import script from "./LessonEditForm.vue?vue&type=script&lang=js&"
export * from "./LessonEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddefa7f",
  null
  
)

export default component.exports